import { Component, OnInit, Optional } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Constantes } from 'src/app/components/shared/constant/constantes';

@Component({
  selector: 'app-menu-alterno',
  templateUrl: './menu-alterno.component.html',
  styleUrls: ['./menu-alterno.component.css']
})
export class MenuAlternoComponent {

  currentPath: string = '';

  constructor(@Optional() private route?: ActivatedRoute) {
    route?.url.subscribe({
      next: url$ => {
        if (url$[0])
          this.currentPath = url$[0].path;
      }
    })    
  }

  public constantes: Constantes = new Constantes();
  private urlBase = window.location.origin;

  public irBuscadorSeries(target?: string){
    var urlbuscador:string= this.urlBase + '/buscador-de-series/';
    if (!target)
      target = "_self"
    window.open(urlbuscador, target);
  }

  public irGraficasInteractivas(target?: string){
    var urlgraficador:string= this.urlBase + '/graficador-series/';
    if (!target)
      target = "_self"
    window.open(urlgraficador, target);
  }

  public irCatalogoRecomendados(target?: string){
    var urlEstadisticas:string= this.urlBase + '/estadisticas-economicas/';
    const url:string = urlEstadisticas+"#/catalogo";
    if (!target)
      target = "_self"
    window.open(url, target);
  }

  public irTablasPreconstruidas(target?: string){
    var urlEstadisticas:string= this.urlBase + '/estadisticas-economicas/';
    const url:string = urlEstadisticas+"#/dashboard";
    if (!target)
      target = "_self"
    window.open(url, target);
  }

  public irIndicadoresEconomicosDia(target?: string){
    var urlEstadisticas:string= this.urlBase + '/indicadores-economicos-del-dia/';
    if (!target)
      target = "_self"
    window.open(urlEstadisticas, target);
  }
  

}
